
import React, { useState, useEffect } from "react";
import { Card, Row, Col, Typography, Button, List, Spin, Modal, Collapse, Space, Divider } from "antd";
import {
    DownloadOutlined, FileExcelOutlined, ExclamationCircleOutlined, ArrowRightOutlined,
    FilePdfOutlined,
    EyeOutlined,
} from "@ant-design/icons";
import { useHistory, useLocation } from "react-router-dom";
import { routes } from "../../routes/Routes";
import _NewapplicationService from "../../modules/NewapplicationService";
import _commonService from "../../modules/commonService";
import LeftLayout from "../pageHeader/LeftLayout";
import "./UploadDocumentsPreview.scss";
import ButtonComponent from "../../components/Button/Button";

const { Text, Title } = Typography;
const { confirm } = Modal;

const UploadDocumentsPreview = () => {
    const history = useHistory();
    const location = useLocation();
    const [Documents, setDocuments] = useState([]);
    const [applicantDetails, setApplicantDetails] = useState({});
    const [loading, setLoading] = useState(false);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [selectedDocUrl, setSelectedDocUrl] = useState("");
    const [selectedDocName, setSelectedDocName] = useState("");
    const [selectedDocType, setSelectedDocType] = useState("");
    let selectedApplicationFlow = null;
    const fromNewAppPage = JSON.parse(
        localStorage.getItem("fromNewApplicationPage")
    );
    const isFromMyAppListPage = JSON.parse(
        localStorage.getItem("isFromMyApplicationsList")
    );

    const locData = location.state;
    if (locData && locData.selectedDocumentOption) {
        selectedApplicationFlow = locData.selectedDocumentOption;
    }
    const [selectedApplicationDocFlow] = useState(selectedApplicationFlow);
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    useEffect(() => {
        // if (!locData) {
        //     history.push(routes.dashboard.path);
        //     return;
        // }
        getApplicantDetailsByID(localStorage.getItem("ApplicationObjId"));
    }, []);

    useEffect(() => {
        if (localStorage.getItem("ApplicationObjId")) {
            getConsumerReportByConsumerId(localStorage.getItem("ApplicationObjId"));
        }
    }, [localStorage.getItem("ApplicationObjId")]);

    const getConsumerReportByConsumerId = async () => {
        try {
            setLoading(true);
            const res = await _NewapplicationService.getApplicantInformationByAppId(localStorage.getItem("ApplicationObjId"));

            const list = res?.data?.listApplicantDocs || [];

            // setDocuments(
            //     list
            //         .map((doc, index) => ({
            //             id: index + 1,
            //             name: doc.DocName,
            //             url: doc.DocPath,
            //             type: doc.DocType?.replace(".", "").toUpperCase(), // PDF / XLSX
            //             size: doc.DocSize,
            //             uploadedOn: doc.DocCreatedDate,
            //         }))
            //         .filter(doc => doc.type === "PDF" || doc.type === "XLSX")
            // );

            const groupedDocuments = list.map((doc, index) => {
                const urls = doc.DocPath
                    ? doc.DocPath.split(",").filter(Boolean)
                    : [];

                return {
                    id: index + 1,
                    name: doc.DocName,
                    url: doc.DocPath,
                    type: doc.DocType?.replace(".", "").toUpperCase(),
                    size: doc.DocSize,
                    uploadedOn: doc.DocCreatedDate,
                    isMulti: urls.length > 1,
                    files: urls.map((url) => ({
                        name: url.split("?")[0].split("/").pop(),
                        url,
                        type: doc.DocType?.replace(".", "").toUpperCase(),
                    })),
                };
            });

            setDocuments(groupedDocuments);
        } catch (error) {
            console.error("Failed to load reports", error);
        } finally {
            setLoading(false);
        }
    };

    const getApplicantDetailsByID = async (id) => {
        setLoading(true);
        try {
            const res =
                await _NewapplicationService.getApplicantInformationByApplicationId(id);
            if (res?.data) setApplicantDetails(res.data);
        } catch (e) {
            console.log(e);
        } finally {
            setLoading(false);
        }
    };


    const onView = (doc) => {
        setSelectedDocName(doc.name);
        setSelectedDocUrl(doc.url);
        setSelectedDocType(doc.type);
        setIsModalVisible(true);
    };



    const onDownload = (doc) => {
        const link = document.createElement("a");
        link.href = doc.url;
        link.download = doc.url.split("/").pop();
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    /* ---------- NAV ---------- */

    const onBack = () => {
        if (fromNewAppPage || isFromMyAppListPage) {
            history.push({ pathname: routes.uploaddocuments.path, state: { isFromDashboard: false } });
        } else {
            history.push(routes.myApplications.path);
        }
    };

    const onSaveNext = () => {
        if (selectedApplicationDocFlow == "manualentry") {
            localStorage.setItem("selectedDocumentOption", selectedApplicationDocFlow);
            history.push({ pathname: routes.incomeSources.path, state: { selectedDocumentOption: selectedApplicationDocFlow, applicationObjId: localStorage.getItem("ConsumerUserId") } });
            localStorage.setItem("IsQuestionairCompleted", false);
            localStorage.setItem("IsFromManualFlow", false);
        } else {
            confirm({
                title:
                    "Once you upload, our platform will complete a preliminary financial assessment. Please review all inputs carefully.",
                icon: <ExclamationCircleOutlined />,
                okText: "Upload Application",
                cancelText: "Cancel",
                width: 600,
                onOk() {
                    history.push({ pathname: routes.dashboard.path, state: { activeKey: "2" } });
                    localStorage.setItem("IsQuestionairCompleted", false);
                    localStorage.setItem("IsFromUploadPFS", true);
                }
            });
        }
    };



    /* ---------- Helper ---------- */
    const formatCurrency = (value) =>
        `$${Number(value || 0).toLocaleString()}`;

    const formatPercentage = (value) =>
        `${Number(value || 0).toFixed(2)}%`;


    return (
        <Spin spinning={loading}>
            <LeftLayout >
                <div className="preview-root-wrapper">
                    <div className="preview-container">



                        <Card className="preview-card">
                            <div className="preview-inner">

                                {/* ===== Uploaded Documents ===== */}
                                <Title level={1} className="preview-header-title">
                                    Uploaded Documents
                                </Title>

                                <div className="section-container">
                                    <div className="preview-doc-list">
                                        <Text className="preview-subtitle">Document List</Text>
                                        <List
                                            dataSource={Documents}
                                            renderItem={(item) => (
                                                <List.Item
                                                    className={item.isMulti ? "dBlock preview-doc-row" : "preview-doc-row"}
                                                    actions={
                                                        item.isMulti
                                                            ? []
                                                            : [
                                                                <Button
                                                                    type="link"
                                                                    className="view-btn"
                                                                    onClick={() => onView(item)}
                                                                >
                                                                    View
                                                                </Button>,
                                                                <Button
                                                                    type="button"
                                                                    icon={<DownloadOutlined />}
                                                                    className="delete-btn" onClick={() => onDownload(item)}
                                                                />,
                                                            ]
                                                    }
                                                >

                                                    <div className="doc-item-content">
                                                        <div className="doc-icon-box">
                                                            <FileExcelOutlined />
                                                        </div>

                                                        {/* <div className="doc-text-info">
                                                            <Text className="priviewdocname">{item.name}</Text>
                                                            <Text type="secondary" className="priview-doc-meta">
                                                                <span>Uploaded</span> {item.uploadedOn}

                                                            </Text>
                                                        </div> */}

                                                        <div className="doc-text-info">
                                                            <Text className="priviewdocname">
                                                                {item.name}
                                                            </Text>

                                                            <Text
                                                                type="secondary"
                                                                className="priview-doc-meta"
                                                            >
                                                                Uploaded {item.uploadedOn}
                                                            </Text>
                                                        </div>
                                                    </div>

                                                    {item.isMulti && (
                                                        <div className="multi-file-container dividerColor">
                                                            {item.files.map((file, idx) => (
                                                                <div
                                                                    key={idx}
                                                                    className="multi-file-row"
                                                                >
                                                                    <span className="multi-file-name">
                                                                        {file.name}
                                                                    </span>

                                                                    <Space size={8} className="mr5">
                                                                        <Button
                                                                            type="link"
                                                                            className="view-btn"
                                                                            onClick={() =>
                                                                                onView({
                                                                                    name: file.name,
                                                                                    url: file.url,
                                                                                    type: file.type,
                                                                                })
                                                                            }
                                                                        >
                                                                            View
                                                                        </Button>

                                                                        <Divider type="vertical" />

                                                                        <Button
                                                                            type="button"
                                                                            icon={<DownloadOutlined />}
                                                                            className="delete-btn"
                                                                            onClick={() =>
                                                                                onDownload({
                                                                                    url: file.url,
                                                                                })
                                                                            }
                                                                        />
                                                                    </Space>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    )}


                                                </List.Item>
                                            )}
                                        />


                                    </div>
                                </div>

                                {/* ===== Metrics ===== */}


                                <Card className="section-card">
                                    <div>
                                        <Text className="preview-subtitle">Loan Summary Metrics</Text>

                                        <Row gutter={[24, 12]}>
                                            <Metric
                                                label="Requested Loan Amount"
                                                value={
                                                    applicantDetails?.App_Det_LoanAmount
                                                        ? `$ ${_commonService.formatNumberWithCommas(applicantDetails.App_Det_LoanAmount)}`
                                                        : "N/A"
                                                }
                                            />
                                            <Metric label="CBR Score" value={applicantDetails && applicantDetails.CBRScore || "N/A"} />
                                            <Metric
                                                label="Net Worth"
                                                value={
                                                    applicantDetails?.CalNetworthTotal
                                                        ? `$ ${_commonService.formatNumberWithCommas(applicantDetails.CalNetworthTotal)}`
                                                        : "N/A"
                                                }
                                            />
                                            <Metric label="Leverage" value={applicantDetails && applicantDetails.CalLevridge || "N/A"} />
                                            <Metric label="TDSR (Total Debt Servicing Ratio)" value={applicantDetails && applicantDetails.CalTDSRAmount ? applicantDetails && applicantDetails.CalTDSRAmount + " %" : "N/A"} />
                                            <Metric label="Debt-to-Income Ratio" value={applicantDetails && applicantDetails.CalDebtIncomeRatio ? applicantDetails && applicantDetails.CalDebtIncomeRatio + " %" : "N/A"} />
                                        </Row>
                                    </div>
                                </Card>

                                <div className="preview-note-container">
                                    <Text className="preview-note">
                                        <span className="note-bold">Note:  </span>
                                        These metrics are calculated based on your uploaded documents.Please review carefully before
                                        submitting your application.
                                    </Text>
                                </div>

                                <div className="loan-footer-wrapper">

                                    <ButtonComponent
                                        type="default"
                                        onClick={onBack}
                                        text={"Back"}
                                    />
                                    <ButtonComponent
                                        type="primary"
                                        onClick={onSaveNext}
                                        text={
                                            <span>
                                                Save And Proceed <ArrowRightOutlined />
                                            </span>
                                        }
                                    // text={"Save & Next"}
                                    />

                                </div>

                            </div>
                        </Card>



                    </div>
                </div>

                {/* ===== Document Viewer ===== */}
                <Modal
                    visible={isModalVisible}   // 👈 FIXED
                    title={selectedDocName}
                    footer={null}
                    onCancel={() => setIsModalVisible(false)}
                    width="70vw"
                    destroyOnClose
                >
                    {selectedDocType === "PDF" && (
                        <iframe
                            src={`https://docs.google.com/gview?url=${encodeURIComponent(
                                selectedDocUrl
                            )}&embedded=true`}
                            style={{ width: "100%", height: "70vh", border: "none" }}
                            title="pdf"
                        />
                    )}

                    {selectedDocType === "XLSX" && (
                        <iframe
                            src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
                                selectedDocUrl
                            )}&footer=false`}
                            style={{ width: "100%", height: "70vh", border: "none" }}
                            title="excel"
                        />
                    )}
                </Modal>
            </LeftLayout>
        </Spin>
    );
};

const Metric = ({ label, value }) => (
    <Col xs={24} sm={12} md={12}>
        <div className="metric-card">
            <Text className="metric-label">{label}</Text>
            <Text className="metric-value">{value}</Text>
        </div>
    </Col>
);

export default UploadDocumentsPreview;